import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import CardsListPage from '../../../pages/Cards/CardsListPage';
import CardsListMobile from '../../../pages/Mobile/Cards/CardsListMobile';

const CardsListResponsive: React.FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <CardsListMobile /> : <CardsListPage />;
};

export default CardsListResponsive;
